import { ISelectOption } from '../components';

export const optionsFromDisplay = (obj: { [key: string]: string }): ISelectOption<string>[] => {
  // old way:
  // return Object.keys(obj).reduce((p, c) => [...p, { label: obj[c], value: c }], [] as ISelectOption<string>[]);
  return Object.entries(obj).map(([key, value]) => ({ label: value, value: key }));
};
